export const payoutAccountTypeLabels = {
  "wise": "Wise",
  "xendit": "Xendit"
}